import React from "react";
import {TVisitFields} from "../../../../../types/visit";
import Icon from "../../../general/icon";
import {general} from "../../../../../store/action";
import {connect} from "react-redux";

type IhioReferencePrescriptionDetailsProps = {
    visitDetailsData?: TVisitFields
    handleShowModal: any;
}

const IhioReferencePrescriptionDetails = ({
    visitDetailsData,
    handleShowModal
}: IhioReferencePrescriptionDetailsProps) => {

    return (
        <>
            {visitDetailsData?.ihioTrackingCodeReference && (
                <div
                    className={'w-100 d-flex justify-content-between align-items-center rounded rounded-4 border border-info bg-white mt-3 py-3 px-4'}>
                    <div className={'d-flex align-items-center gap-3'}>
                        بیمار {visitDetailsData?.patient?.name}  به
                        شما ارجاع داده شده است. برای مشاهده نسخه تجویز شده بر روی دکمه کلیک نمایید.
                    </div>

                    <div
                        className="d-flex align-items-center justify-content-center justify-content-md-start m-md-0">
                        <span
                            onClick={() => handleShowModal('referencePrescriptionModal',
                                {
                                    visitId: visitDetailsData?.id,
                                })}
                            className="btn btn-navy-blue rounded d-flex align-items-center px-4 mx-2 mb-3">
                          <span className="d-inline-flex font-25 ms-2 ps-2"><Icon name="eye"/></span>
                          مشاهده نسخه ارجاع
                        </span>
                    </div>
                </div>
            )}
            {/*<ReferencePrescriptionModal*/}
            {/*    visible={referencePrescriptionModalVisible}*/}
            {/*    setVisible={setReferencePrescriptionModalVisible}*/}
            {/*    visitId={visitDetailsData?.id}*/}
            {/*/>*/}
        </>

    )
}


const mapDispatchToProps = (dispatch: any) => ({
    handleShowModal: (data: any, body: any) => dispatch(general.handleShowModal(data, body)),
});

export default connect(null, mapDispatchToProps)(IhioReferencePrescriptionDetails);